import { render } from "./TabsSelector.vue?vue&type=template&id=f876ed3c&scoped=true"
import script from "./TabsSelector.vue?vue&type=script&lang=js"
export * from "./TabsSelector.vue?vue&type=script&lang=js"

import "./TabsSelector.vue?vue&type=style&index=0&id=f876ed3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f876ed3c"]])

export default __exports__